import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import {
  Chart as ChartJS,
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from 'chart.js';
import { Doughnut, Bar } from 'react-chartjs-2';
import { FaExclamationTriangle } from 'react-icons/fa';
import {
  FAIXAS,
  TOTAL_LOTES,
  META_ATE_6SM,
  META_6_A_10SM,
  META_LIVRE,
} from './constantes';

ChartJS.register(ArcElement, CategoryScale, LinearScale, BarElement, Tooltip, Legend);

var CardResumo = function (props) {
  return (
    <Col>
      <Card
        className="text-center d-flex"
        style={{
          borderLeft: '4px solid ' + props.cor,
          marginBottom: 12,
          height: 'calc(100% - 12px)',
        }}
      >
        <Card.Body className="d-flex flex-column justify-content-center" style={{ padding: '10px 12px' }}>
          <div style={{ fontSize: 11, color: '#666' }}>{props.titulo}</div>
          <div style={{ fontSize: 22, fontWeight: 700, color: props.cor }}>
            {props.valor}
          </div>
          <div style={{ fontSize: 10, color: '#999', minHeight: 15 }}>
            {props.subtitulo || '\u00A0'}
          </div>
        </Card.Body>
      </Card>
    </Col>
  );
};

var GraficosEnquadramento = function (props) {
  var contagens = props.contagens;
  var pastaCompletaSemRenda = props.pastaCompletaSemRenda;
  var vendas = props.vendas || { ate6sm: 0, de6a10sm: 0, livre: 0, naoInformada: 0 };
  var totalVendas = props.totalVendas || 0;

  if (!contagens || contagens.todos === 0) {
    return null;
  }

  // Metas absolutas da lei (com base no total de lotes)
  var metaAbsAte6sm = Math.ceil(TOTAL_LOTES * META_ATE_6SM / 100);
  var metaAbsDe6a10sm = Math.floor(TOTAL_LOTES * META_6_A_10SM / 100);
  var metaAbsLivre = Math.floor(TOTAL_LOTES * META_LIVRE / 100);

  // Percentual de atingimento da meta
  var percAte6sm = metaAbsAte6sm > 0
    ? ((contagens.ate6sm / metaAbsAte6sm) * 100).toFixed(1)
    : 0;
  var percDe6a10sm = metaAbsDe6a10sm > 0
    ? ((contagens.de6a10sm / metaAbsDe6a10sm) * 100).toFixed(1)
    : 0;
  var percLivre = metaAbsLivre > 0
    ? ((contagens.livre / metaAbsLivre) * 100).toFixed(1)
    : 0;

  var doughnutData = {
    labels: [
      FAIXAS.ATE_6SM.label + ' (' + contagens.ate6sm + ')',
      FAIXAS.DE_6_A_10SM.label + ' (' + contagens.de6a10sm + ')',
      FAIXAS.LIVRE.label + ' (' + contagens.livre + ')',
      FAIXAS.NAO_INFORMADA.label + ' (' + contagens.naoInformada + ')',
    ],
    datasets: [
      {
        data: [
          contagens.ate6sm,
          contagens.de6a10sm,
          contagens.livre,
          contagens.naoInformada,
        ],
        backgroundColor: [
          FAIXAS.ATE_6SM.cor,
          FAIXAS.DE_6_A_10SM.cor,
          FAIXAS.LIVRE.cor,
          FAIXAS.NAO_INFORMADA.cor,
        ],
        borderWidth: 2,
      },
    ],
  };

  var doughnutOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: 'bottom', labels: { font: { size: 11 } } },
    },
  };

  // Percentual de vendas sobre a meta
  var percVendasAte6sm = metaAbsAte6sm > 0
    ? ((vendas.ate6sm / metaAbsAte6sm) * 100).toFixed(1)
    : 0;
  var percVendasDe6a10sm = metaAbsDe6a10sm > 0
    ? ((vendas.de6a10sm / metaAbsDe6a10sm) * 100).toFixed(1)
    : 0;
  var percVendasLivre = metaAbsLivre > 0
    ? ((vendas.livre / metaAbsLivre) * 100).toFixed(1)
    : 0;

  var barData = {
    labels: [FAIXAS.ATE_6SM.label, FAIXAS.DE_6_A_10SM.label, FAIXAS.LIVRE.label],
    datasets: [
      {
        label: 'Atingido %',
        data: [
          parseFloat(percAte6sm),
          parseFloat(percDe6a10sm),
          parseFloat(percLivre),
        ],
        backgroundColor: [FAIXAS.ATE_6SM.cor, FAIXAS.DE_6_A_10SM.cor, FAIXAS.LIVRE.cor],
        borderWidth: 1,
      },
      {
        label: 'Vendas %',
        data: [
          parseFloat(percVendasAte6sm),
          parseFloat(percVendasDe6a10sm),
          parseFloat(percVendasLivre),
        ],
        backgroundColor: ['#6f42c1', '#6f42c1', '#6f42c1'],
        borderWidth: 1,
      },
      {
        label: 'Meta Lei %',
        data: [100, 100, 100],
        backgroundColor: ['rgba(0,0,0,0.1)', 'rgba(0,0,0,0.1)', 'rgba(0,0,0,0.1)'],
        borderColor: ['#333', '#333', '#333'],
        borderWidth: 2,
        borderDash: [5, 5],
      },
    ],
  };

  var barOptions = {
    indexAxis: 'y',
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        min: 0,
        ticks: {
          callback: function (value) {
            return value + '%';
          },
        },
      },
    },
    plugins: {
      legend: { position: 'bottom', labels: { font: { size: 11 } } },
      tooltip: {
        callbacks: {
          label: function (context) {
            var metasAbs = [metaAbsAte6sm, metaAbsDe6a10sm, metaAbsLivre];
            var reaisAbs = [contagens.ate6sm, contagens.de6a10sm, contagens.livre];
            var vendasAbs = [vendas.ate6sm, vendas.de6a10sm, vendas.livre];
            var metasPerc = [META_ATE_6SM, META_6_A_10SM, META_LIVRE];
            if (context.datasetIndex === 2) {
              return 'Meta: ' + metasAbs[context.dataIndex] + ' lotes (' + metasPerc[context.dataIndex] + '% dos lotes)';
            }
            if (context.datasetIndex === 1) {
              return 'Vendas: ' + vendasAbs[context.dataIndex] + ' de ' + metasAbs[context.dataIndex] + ' (' + context.parsed.x + '%)';
            }
            return 'Atingido: ' + reaisAbs[context.dataIndex] + ' de ' + metasAbs[context.dataIndex] + ' (' + context.parsed.x + '%)';
          },
        },
      },
    },
  };

  return (
    <div style={{ marginBottom: 20 }}>
      <Row>
        <CardResumo
          titulo="Total Leads"
          valor={contagens.todos}
          cor="#6c757d"
          subtitulo={'de ' + TOTAL_LOTES + ' lotes'}
        />
        <CardResumo
          titulo={FAIXAS.ATE_6SM.label}
          valor={contagens.ate6sm}
          cor={FAIXAS.ATE_6SM.cor}
          subtitulo={'Meta: ' + metaAbsAte6sm + ' (' + META_ATE_6SM + '%) — ' + percAte6sm + '% atingido'}
        />
        <CardResumo
          titulo={FAIXAS.DE_6_A_10SM.label}
          valor={contagens.de6a10sm}
          cor={FAIXAS.DE_6_A_10SM.cor}
          subtitulo={'Meta: ' + metaAbsDe6a10sm + ' (' + META_6_A_10SM + '%) — ' + percDe6a10sm + '% atingido'}
        />
        <CardResumo
          titulo={FAIXAS.LIVRE.label}
          valor={contagens.livre}
          cor={FAIXAS.LIVRE.cor}
          subtitulo={'Meta: ' + metaAbsLivre + ' (' + META_LIVRE + '%) — ' + percLivre + '% atingido'}
        />
        <CardResumo
          titulo={FAIXAS.NAO_INFORMADA.label}
          valor={contagens.naoInformada}
          cor={FAIXAS.NAO_INFORMADA.cor}
        />
        <CardResumo
          titulo="Total Vendas"
          valor={totalVendas}
          cor="#6f42c1"
          subtitulo={'de ' + contagens.todos + ' leads'}
        />
        <CardResumo
          titulo="Pasta s/ Renda"
          valor={pastaCompletaSemRenda}
          cor="#fd7e14"
          subtitulo="Doc. completa sem renda"
        />
      </Row>

      <Row>
        <Col md={5}>
          <Card style={{ marginBottom: 16 }}>
            <Card.Header style={{ fontSize: 13, fontWeight: 600 }}>
              Distribuição por Faixa de Renda
            </Card.Header>
            <Card.Body style={{ height: 280 }}>
              <Doughnut data={doughnutData} options={doughnutOptions} />
            </Card.Body>
          </Card>
        </Col>
        <Col md={7}>
          <Card style={{ marginBottom: 16 }}>
            <Card.Header style={{ fontSize: 13, fontWeight: 600 }}>
              Atingimento da Meta da Lei
            </Card.Header>
            <Card.Body style={{ height: 280 }}>
              <Bar data={barData} options={barOptions} />
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {pastaCompletaSemRenda > 0 && (
        <div
          className="alert alert-warning d-flex align-items-center"
          style={{ fontSize: 13 }}
        >
          <FaExclamationTriangle className="mr-2" />
          <span>
            <strong>{pastaCompletaSemRenda}</strong> lead(s) com pasta completa
            mas sem comprovante de renda preenchido. Verifique na tabela (coluna ⚠).
          </span>
        </div>
      )}
    </div>
  );
};

export default GraficosEnquadramento;
